<template>
	<input class="base-input" />
</template>

<style lang="scss">
.base-input {
	@include form-input;
}
</style>
